@layer refine.base {
  :host {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
    vertical-align: middle;
    color: inherit;
  }

  :host([hidden]) {
    display: none;
  }

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}

/* Unlayered: always wins over any @layer rule, including refine.overrides */
:host {
  width: var(--ore-icon-size, var(--_size-px));
  height: var(--ore-icon-size, var(--_size-px));
}
